<template>
    <div class="container">
        <loading-animation v-if="loading" minHeight="700" />
        <div v-else>
            <Form ref="info" :labelWidth="120" :rules="innerRules">
                <!-- 合同信息 -->
                <contract-info
                    prop="contract"
                    :type="routerType"
                    v-model="contract"
                    viewonly
                    justRead
                    class="contract-content-class"
                />
                <Divider />
                <!-- 租客信息 -->
                <customer-info
                    prop="cus"
                    :type="routerType"
                    v-model="cus"
                    viewonly
                    justRead
                    class="contract-content-class"
                    :isShowEditBtn="false"
                    :contractId="contract.id"
                    :houseName="contract.houseName"
                />
                <Divider />
                <!-- 租约信息 -->
                <lease-info-original
                    prop="leaseOriginal"
                    v-model="originalLease"
                    title="租约信息"
                    :type="routerType"
                    :leaseLeftAmountTextOriginal="leaseLeftAmountTextOriginal"
                    class="contract-content-class"
                />
                <Divider />
                <!-- 费用清算 -->
                <expense-settlement
                    prop="expense"
                    v-model="expenseSettlement"
                    :discount="originalLease.discount"
                    :startDate="startDate"
                    :endDate="endDate"
                    :type="routerType"
                    :cancelRentType="cancelRentType"
                    :isAllRentPaid="isAllRentPaid"
                    :loading="loadingExpenseSettlement"
                    text="退租时间"
                    class="contract-content-class"
                    @on-condition-change="getExpenseSettlementList"
                    @on-change="expenseDataChange"
                    isSurrender
                />
                <!-- 读数清算 -->
                <meter-settlement
                    prop="meter"
                    v-model="meterSettlement"
                    v-if="meterSettlement.length"
                    class="contract-content-class"
                />
                <!-- 收支状态 -->
                <div style="margin-top: 20px" class="contract-content-class">
                    <Row :gutter="20">
                        <Col span="8">
                            <FormItem label="收支状态">
                                <check-tag-group
                                    style="display: inline-block"
                                    v-model="clearing.isPay"
                                    color="primary"
                                    unpopulated
                                >
                                    <check-tag
                                        name="1"
                                        style="margin-right: 10px"
                                    >
                                        已收支
                                    </check-tag>
                                    <check-tag
                                        name="0"
                                        style="margin-right: 10px"
                                    >
                                        未收支
                                    </check-tag>
                                </check-tag-group>
                            </FormItem>
                        </Col>
                        <Col span="8" v-if="clearing.isPay[0] === '1'">
                            <FormItem label="交易方式" prop="clearingPayType">
                                <Select
                                    v-model="clearing.payType"
                                    transfer
                                    style="display: inline-block; width: 150px"
                                >
                                    <Option
                                        v-for="(
                                            item, index
                                        ) in this.dict.payType.toList()"
                                        :value="item.id"
                                        :key="index"
                                        >{{ item.text }}</Option
                                    >
                                </Select>
                            </FormItem>
                        </Col>
                        <Col span="8" v-else>
                            <FormItem
                                label="应收 / 付款日"
                                prop="clearingPlanDate"
                            >
                                <DatePicker
                                    v-model="clearing.planDate"
                                    transfer
                                    type="date"
                                    clearable
                                    style="width: 160px"
                                />
                            </FormItem>
                        </Col>
                    </Row>
                    <Row :gutter="20">
                        <Col span="8">
                            <FormItem
                                label="是否地址迁移"
                                label-position="left"
                            >
                                <check-tag-group
                                    style="display: inline-block"
                                    v-model="clearing.migrate"
                                    color="primary"
                                    unpopulated
                                >
                                    <check-tag
                                        name="1"
                                        style="margin-right: 10px"
                                    >
                                        是
                                    </check-tag>
                                    <check-tag
                                        name="0"
                                        style="margin-right: 10px"
                                    >
                                        否
                                    </check-tag>
                                </check-tag-group>
                            </FormItem>
                        </Col>
                    </Row>
                </div>
            </Form>
            <!-- 按钮信息 -->
            <div style="height: 200px"></div>
            <div class="btn-container">
                <Button
                    style="margin-right: 10px"
                    @click="submit"
                    type="primary"
                >
                    确定
                </Button>
                <Button @click="cancelSurrender">取消</Button>
            </div>
            <!-- 弹出层 -->
            <smart-modal
                v-model="modal.showChargeDetails"
                title="清算明细"
                :width="800"
                :height="600"
                :maskClosable="false"
                @close-by-confirm="toContract"
            >
                <charge-details
                    v-if="modal.showChargeDetails"
                    :value="chargeDetails"
                    :remark.sync="clearing.remark"
                />
            </smart-modal>
        </div>
    </div>
</template>

<script>
import { deepCopy, ymd, currency, dayjs, tagEqual } from '_u/helper'
import Dict from '_u/dict'
import {
    initExpenseSettlement,
    formateMeterSettlement,
    formateExpenseSettlement,
    formateLeaseReverse,
} from '@/views/common/u-contract'
import { mapMutations } from 'vuex'

import ContractInfo from './children/contract-info'
import CustomerInfo from './children/customer-info'
import LeaseInfoOriginal from './children/lease-info-original'
import ExpenseSettlement from './children/expense-settlement'
import MeterSettlement from './children/meter-settlement'
import ChargeDetails from '_v/components/charge-details'
import LoadingAnimation from '_v/components/loading-animation'

import {
    contractView,
    contractCancelRent,
    expenseBillListCreate,
    houseMeterList,
    queryCancelRentType,
} from '@/api/contract'

// 合同-退租
export default {
    name: 'contractSurrender',
    components: {
        ContractInfo,
        CustomerInfo,
        LeaseInfoOriginal,
        ExpenseSettlement,
        MeterSettlement,
        ChargeDetails,
        LoadingAnimation,
    },
    data() {
        return {
            loading: false,
            loadingExpenseSettlement: false,
            id: this.$route.params.id,
            contract: {}, // 合同信息
            cus: {}, // 租客信息
            originalLease: {}, // 原租约信息
            facility: [], // 合同设施
            bills: [], // 账单信息
            startDate: '', // 合同开始日期
            endDate: '', // 合同结束日期
            dict: {
                feeType: Dict.NULL,
                meterType: Dict.NULL,
                payType: Dict.NULL,
            },
            modal: {
                showChargeDetails: false,
            },
            formData: '',
            // 费用清算
            expenseSettlement: {
                list: [],
                date: new Date(),
                cancelRentType: ['1'],
                isDeductionByLast: '1',
            },
            cancelRentType: '', // 退租类型
            isAllRentPaid: false, // 租金是否全部交纳
            meterSettlement: [], // 读数清算
            metersJSON: '', // 读数清算JSON字符串
            chargeDetails: [], // 费用明细
            clearing: {
                isPay: ['1'], // 是否收支(0:未收支/1:已收支)
                payType: '', // 支付类型
                planDate: new Date(), // 应收/应付日期
                changeType: ['1'], //变更类型1:换房/2:退房(是否地址迁移)
                migrate: ['1'], // 是否迁移：0否，1是
                remark: '',
            },
            routerContractId: this.$route.query.contractId, // 合同id
            routerType: this.$route.query.type, // 合同类型
            leaseLeftAmountTextOriginal: '', // 其他押金与常规押金进行拼接字符串
        }
    },
    created() {
        this.fetch()
    },
    computed: {
        innerRules() {
            const rule = {}
            if (this.clearing.isPay[0] === '1') {
                rule.clearingPayType = [
                    { required: true, message: '交易方式必填' },
                ]
            } else {
                rule.clearingPlanDate = [
                    { required: true, message: '应收/付款日必填' },
                ]
            }
            return rule
        },
    },

    methods: {
        ...mapMutations(['setTagNavList']),
        fetch() {
            this.loading = true

            // 退租，请求原来合同的信息
            Promise.all([
                Dict.get(['fee_type', 'meter_type', 'pay_type']),
                contractView(this.routerContractId),
                queryCancelRentType(this.routerContractId),
            ])
                .then((args) => {
                    var [dictGroup, view, cancelRentType] = args

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })
                    this.formateView(view)
                    this.cancelRentType = cancelRentType.data.cancelRentType // 退租类型
                    this.isAllRentPaid = cancelRentType.data.isAllRentPaid // 是否全部交纳
                    this.expenseSettlement.cancelRentType[0] = this.cancelRentType
                    // 到期退租
                    if (this.cancelRentType === '1') {
                        return expenseBillListCreate({
                            contractId: this.routerContractId,
                            changeDate: this.endDate,
                            changeType: '2',
                        })
                    }
                    // 违约退租
                    else if (this.cancelRentType === '2') {
                        return expenseBillListCreate({
                            contractId: this.routerContractId,
                            changeDate: dayjs().format('YYYY-MM-DD'),
                            changeType: '2',
                        })
                    }
                    // 逾期退租
                    else if (this.cancelRentType === '3') {
                        return expenseBillListCreate({
                            contractId: this.routerContractId,
                            changeDate: dayjs().format('YYYY-MM-DD'),
                            changeType: '2',
                        })
                    }
                })
                .then((res) => {
                    initExpenseSettlement(res, this.expenseSettlement)
                    this.initPayStatus()
                    return houseMeterList(this.contract.houseId)
                })
                .then((meterSettlement) => {
                    this.initMeterSettlement(meterSettlement)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        // 费用列表查询数据更改
        getExpenseSettlementList() {
            let changeDate = ymd(this.expenseSettlement.date)
            // 到期退租为合同终止日期
            if (this.expenseSettlement.cancelRentType[0] === '1') {
                changeDate = this.endDate
            }

            this.loadingExpenseSettlement = true
            expenseBillListCreate({
                contractId: this.contract.id,
                changeDate,
                changeType: '2',
            })
                .then((res) => {
                    initExpenseSettlement(res, this.expenseSettlement)
                    this.initPayStatus()
                })
                .finally(() => {
                    this.loadingExpenseSettlement = false
                })
        },
        // 费用列表相关数据更改
        expenseDataChange() {
            const list = this.expenseSettlement.list
            list.forEach((v) => {
                // 只要是退款，账单状态改为应付
                if (v.isReceive === '2') {
                    v.planAmount = v.refund
                    v.billStatus = '3'
                }
                // 是收款，账单状态改为应收
                else if (v.isReceive === '1') {
                    v.planAmount = v.receivables
                    v.billStatus = '1'
                }
            })
            this.initPayStatus()
        },
        // 收支状态初始化
        initPayStatus() {
            var list = this.expenseSettlement.list
            // 清算统计为正数，则已收支，否则未收支
            var totalPrice = list.reduce((acc, v) => {
                if (v.isReceive === '1') {
                    acc += v.receivables - 0
                } else if (v.isReceive === '2') {
                    acc -= v.refund - 0
                }
                return acc
            }, 0)
            if (totalPrice >= 0) {
                this.clearing.isPay = ['1']
            } else {
                this.clearing.isPay = ['0']
                this.clearing.planDate = new Date() // 默认当天
            }
        },
        // 格式化view数据
        formateView(view) {
            const {
                entity,
                contractCus,
                facilityList,
                changeInfo,
                contractLease,
                leftList,
            } = view.data
            // 合同开始结束日期
            this.startDate = contractLease.startDate
            this.endDate = contractLease.endDate
            // 合同
            this.contract = entity
            // 客户
            Object.keys(contractCus).forEach((name) => {
                contractCus[name] = contractCus[name] || ''
            })
            this.cus = contractCus
            // 租约
            facilityList.forEach((v) => {
                v.parentId = v.pid
                v.price /= 100
            })

            formateLeaseReverse(contractLease)
            this.originalLease = contractLease
            this.originalLease.leaseDate = `${this.originalLease.startDate} 至 ${this.originalLease.endDate}`
            this.originalLease.signUser = entity.signUser
            this.originalLease.fList = facilityList
            this.originalLease.agentUser = this.$store.state.user.info.nickName

            //显示原来的 押金总额=常规押金+增收押金+其它押金列表
            let totalDepositOriginal = 0
            let leftAmountTextArrOriginal = []
            const feeTypeDict = this.dict.feeType
            leftList.forEach((v) => {
                totalDepositOriginal += v.planAmount / 100 || 0
                leftAmountTextArrOriginal.push(
                    `${feeTypeDict.val(v.feeType)} ${currency(
                        v.planAmount / 100 || 0
                    )}`
                )
            })
            this.leaseLeftAmountTextOriginal = `${currency(
                totalDepositOriginal
            )}(${leftAmountTextArrOriginal.join(',')})`
        },
        // 抄表初始化
        initMeterSettlement(val) {
            const list = val.data.list || []
            list.forEach((v) => {
                const meter = this.dict.meterType.get(v.meterType)
                v.unit = '元/' + JSON.safeParse(meter?.remark).unit
                v.price = v.price ? v.price / 100 : 0
                v.amount = v.amount ? v.amount / 100 : ''
            })
            this.meterSettlement = list
        },
        // 提交-显示清算明细
        submit() {
            this.$refs.info
                .validate()
                .then(() => {
                    this.chargeDetails = []
                    const list = this.expenseSettlement.list
                    // 费用清算-收款列表
                    let refundList = list.filter((v) => v.isReceive === '1')
                    refundList = this.mergeBill(refundList)
                    this.getChargeDetailsList(
                        this.chargeDetails,
                        refundList,
                        '实际收款费用'
                    )
                    //  费用清算-退款列表
                    let paidList = list.filter((v) => v.isReceive === '2')
                    paidList = this.mergeBill(paidList)
                    this.getChargeDetailsList(
                        this.chargeDetails,
                        paidList,
                        '实际退款费用'
                    )
                    // 抄表费用
                    let meterList = deepCopy(this.meterSettlement)
                    this.getChargeMeterList(
                        this.chargeDetails,
                        meterList,
                        '抄表费用'
                    )
                    this.modal.showChargeDetails = true
                })
                .catch((err) => {
                    this.$Message.error(err[0].message)
                })
        },
        // 合并相同的费用
        mergeBill(list) {
            list = deepCopy(list)
            const feeTypeObj = {}
            const newList = []
            list.forEach((v) => {
                if (feeTypeObj[v.feeType] === true) {
                    const item = newList.find((p) => p.feeType === v.feeType)
                    item.planAmount =
                        parseFloat(item.planAmount) + parseFloat(v.planAmount)
                } else {
                    newList.push(v)
                    feeTypeObj[v.feeType] = true
                }
            })
            return newList
        },
        // 费用清算列表——收款退款
        getChargeDetailsList(chargeDetails, list, title) {
            if (list.length > 0) {
                const obj = {
                    title,
                    list: [],
                }
                // 一行5个数据
                let newItem = true
                list.forEach((v) => {
                    if (newItem) {
                        obj.list.push([])
                        newItem = false
                    }
                    obj.list[obj.list.length - 1].push({
                        text: this.dict.feeType.val(v.feeType),
                        val: currency(v.planAmount) + '元',
                    })
                    if (obj.list[obj.list.length - 1].length === 5) {
                        newItem = true
                    }
                })
                chargeDetails.push(obj)
            }
        },
        // 费用清算列表——抄表
        getChargeMeterList(chargeDetails, list, title) {
            if (list.length > 0) {
                const obj = {
                    title,
                    list: [],
                }

                list.forEach((v) => {
                    obj.list.push([
                        {
                            text: v.meterName,
                            val: '',
                        },
                        {
                            text: '上次读数',
                            val: v.lastDegree,
                        },
                        {
                            text: '本次读数',
                            val: v.degree,
                        },
                        {
                            text: '单价',
                            val: v.price,
                        },
                        {
                            text: '合计',
                            val:
                                v.amount === ''
                                    ? ''
                                    : currency(v.amount) + '元',
                        },
                    ])
                })
                chargeDetails.push(obj)
                chargeDetails.remark = ''
            }
        },
        // 取消-返回合同管理
        cancelSurrender() {
            this.$router.push({
                name: 'contractIndex',
            })
        },
        // 合同退租
        contractSurrender() {
            const populateData = deepCopy(this.$refs.info.populateData())
            const data = this.formatePopulateData(populateData)

            data.bills.push({ remark: this.clearing.remark }) // 增加备注字段

            this.metersJSON = JSON.stringify(data.meters)
            const formData = {
                id: this.routerContractId,
                change: JSON.stringify(data.change),
                clearing: JSON.stringify(data.clearing),
                bills: JSON.stringify(data.bills),
                meters: this.metersJSON,
                agentUser: data.agentUser,
            }

            return contractCancelRent(formData)
        },
        // 格式化合同退租的参数
        formatePopulateData(populateData) {
            const data = {}
            // 1 到期退租；2 违约退租
            const changeDate =
                this.expenseSettlement.cancelRentType[0] === '1'
                    ? this.endDate
                    : ymd(this.expenseSettlement.date)
            data.change = {
                migrate: this.clearing.migrate[0],
                changeDate,
                changeReason: populateData.leaseOriginal.changeReason,
            }
            data.clearing = {
                cancelRentType: this.expenseSettlement.cancelRentType[0],
                isPay: this.clearing.isPay[0],
                payType: this.clearing.payType,
                planDate: ymd(this.clearing.planDate),
            }
            const bills = formateExpenseSettlement(this.expenseSettlement.list)
            data.bills = []
            bills.forEach((v) => {
                data.bills.push({
                    startDate: v.startDate,
                    endDate: v.endDate,
                    feeType: v.feeType,
                    planAmount: v.planAmount,
                    billStatus: v.billStatus,
                    isReceive: v.isReceive,
                })
            })
            data.meters = formateMeterSettlement(this.meterSettlement)
            data.agentUser = populateData.leaseOriginal.agentUser
            return data
        },
        // 返回合同管理
        toContract() {
            this.loading = true
            this.contractSurrender()
                // .then(() => {
                //     return meterListUpdate(this.metersJSON);
                // })
                .then(() => {
                    this.loading = false
                    this.$Message.success('退租成功')

                    var list = this.$store.state.app.tagNavList
                    list = list.filter((o) => !tagEqual(o, this.$route))
                    this.setTagNavList(list)

                    this.$router.push({
                        name: 'contractIndex',
                    })
                })
        },
    },
}
</script>

<style lang="less" scoped>
.container {
    position: relative;
}
</style>
